import PortfolioScore from './PortfolioScore'

export default PortfolioScore
